export enum DashboardActionType {
  INIT_QUERY = 'INIT_QUERY',
  SET_QUERY = 'SET_QUERY',
  SET_VISUAL = 'SET_VISUAL',
  SET_LOADING_ANALYSES_BY_ID = 'SET_LOADING_ANALYSES_BY_ID',
  SET_METADATA = 'SET_METADATA',
  SET_DASHBOARD = 'SET_DASHBOARD',
  RESET = 'RESET',
}
